(() => {
  if (customElements.get('atorpok-product-gallery')) return;

  class AtorpokProductGallery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.panels = [...this.querySelectorAll('.gallery-stage > .product-media')];
      this.links = [...this.querySelectorAll('[data-gallery-link]')];
      if (!this.panels.length) return;

      this.show(this.panels[0].id);
      this.setAttribute('data-enhanced', '');

      this.addEventListener('click', event => {
        const link = event.target.closest('[data-gallery-link]');
        if (!link || !this.contains(link)) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const id = link.getAttribute('aria-controls');
        if (!this.panels.some(panel => panel.id === id)) return;
        event.preventDefault();
        this.show(id);
      }, { signal });

      this.addEventListener('keydown', event => {
        const link = event.target.closest('[data-gallery-link]');
        if (!link || !this.links.includes(link)) return;
        const index = this.links.indexOf(link);
        let next;
        switch (event.key) {
          case ' ': next = index; break;
          case 'ArrowRight': case 'ArrowDown': next = (index + 1) % this.links.length; break;
          case 'ArrowLeft': case 'ArrowUp': next = (index - 1 + this.links.length) % this.links.length; break;
          case 'Home': next = 0; break;
          case 'End': next = this.links.length - 1; break;
          default: return;
        }
        event.preventDefault();
        const target = this.links[next];
        this.show(target.getAttribute('aria-controls'));
        target.focus({ preventScroll: true });
        const strip = target.parentElement;
        const left = target.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft) strip.scrollLeft = left;
        else if (left + target.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollLeft = left + target.offsetWidth - strip.clientWidth;
        }
      }, { signal });
    }

    show(id) {
      if (!this.panels.some(panel => panel.id === id)) return;
      for (const panel of this.panels) {
        const active = panel.id === id;
        if (!active && !panel.hidden) {
          panel.querySelectorAll('video').forEach(video => video.pause());
          // Stop external playback when leaving a visible iframe.
          panel.querySelectorAll('iframe').forEach(frame => {
            const src = frame.getAttribute('src');
            if (src) frame.setAttribute('src', src);
          });
        }
        panel.hidden = !active;
      }
      for (const link of this.links) {
        if (link.getAttribute('aria-controls') === id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  }

  customElements.define('atorpok-product-gallery', AtorpokProductGallery);
})();
